import { AIGeneratedFieldChoice } from '@/redux/slices/formAIGenerationSlice'
import { nanoid } from '@reduxjs/toolkit'
import { BuiltFieldAttributes } from './baseFieldBuilder'

type BuiltChoice = NonNullable<BuiltFieldAttributes['choices']>[number]

export default function buildChoices(
  rawChoices: AIGeneratedFieldChoice[] | undefined,
  supportOtherChoice: boolean = true,
  maxLevels: number = 1
): BuiltChoice[] {
  let choices: BuiltChoice[] | undefined
  if (Array.isArray(rawChoices)) {
    choices = rawChoices.map((choice, index) => buildChoice(choice, supportOtherChoice, index, maxLevels))
  }

  if (!choices?.length) {
    choices = generateExampleChoices()
  }

  return choices
}

function buildChoice(
  rawChoice: AIGeneratedFieldChoice,
  supportOtherChoice: boolean,
  index: number,
  maxLevels: number,
  currentLevel: number = 1
): BuiltChoice {
  const choice: BuiltChoice = {
    type:
      rawChoice.type === 'other' && supportOtherChoice
        ? 'OtherChoice'
        : 'Choice',
    name: rawChoice.name,
    value: nanoid(4),
    quotaSetting: rawChoice.quotaSetting,
    quota: rawChoice.quotaSetting,
    descriptionMode: rawChoice.descriptionMode,
    descriptionText: rawChoice.descriptionText,
    descriptionUrl: rawChoice.descriptionUrl,
    position: index
  }

  if (currentLevel < maxLevels) {
    if (rawChoice.subChoices?.length) {
      choice.subChoices = rawChoice.subChoices.map((subChoice, subIndex) =>
        buildChoice(subChoice, supportOtherChoice, subIndex, maxLevels, currentLevel + 1)
      )
    } else {
      choice.subChoices = generateExampleChoices()
    }
  }

  return choice
}

function generateExampleChoices(): BuiltChoice[] {
  return [
    { type: 'Choice', name: '选项一', value: nanoid(4), position: 0 },
    { type: 'Choice', name: '选项二', value: nanoid(4), position: 1 },
    { type: 'Choice', name: '选项三', value: nanoid(4), position: 2 }
  ]
}
